export const ORDER_DATE_FORMAT = 'MM/dd/yyyy';
